import type { PowerPathOverviewTab } from '@ps/web-martech-cms-types';
import { StarsButton, useNavigate } from '@ps/web-shared-components';
import React from 'react';

import { CMSHTML } from '@swf/cms';

import type { NavigationTabTypes, PassBundleRaw } from '../../../../types';
import { NavigationTabs } from '../../../../types';
import HeadingWithAccentedText from '../HeadingWithAccentedText/HeadingWithAccentedText';
import ListCards from '../ListCards/ListCards';

import { TXTCLI_Play_Now } from './PageBundle.messages.json';
import styles from './PageBundle.scss';

interface Props {
  data: PowerPathOverviewTab['passes_to_events'];
  onSelectTab: (tabName: NavigationTabTypes) => void;
  cardData: PassBundleRaw;
}

const PageBundle: React.FC<Props> = ({ data, onSelectTab, cardData }) => {
  const navigate = useNavigate();

  const { description } = data;
  const handleSubmit = () => {
    navigate('/poker/play-poker/power-path/the-path/simple');
    onSelectTab(NavigationTabs.thePath);
  };

  const handleCardClicked = () => {
    navigate('/poker/play-poker/power-path/the-passes');
    onSelectTab(NavigationTabs.thePasses);
  };

  return (
    <div className={styles.root}>
      <HeadingWithAccentedText className={styles.heading} {...data.heading} />
      {cardData && <ListCards passesData={cardData} handleCardClick={handleCardClicked} />}
      <div className={styles.subTitle}>
        {description && <CMSHTML tag="span" preventClick content={description} />}
      </div>
      <StarsButton
        size="large"
        variant="primary"
        onClick={handleSubmit}
        translation={TXTCLI_Play_Now}
      />
    </div>
  );
};

export default PageBundle;
